import type { ComponentProps } from 'react';
import type React from 'react';

import { PageMessage } from '@change-corgi/design-system-legacy/components/alerts';

import { useDashboardReskinExperiment } from '../../../../hooks/useDashboardReskinExperiment';

import { usePageBanner } from './hooks/usePageBanner';
import { PageBanner as PageBannerReskin } from './index_new';

// Casts custom Action type (with preventScrollReset) to legacy PageMessage Action type
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unsafe-type-assertion
const castToPageMessageAction = (action: unknown) => action as ComponentProps<typeof PageMessage>['primaryAction'];

export const PageBanner: React.FC = () => {
	const { data, actions } = usePageBanner();

	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();

	if (!data.banner) return null;

	if (isEnabled) {
		return <PageBannerReskin />;
	}

	return (
		<div className="col-span-full">
			<PageMessage
				id="starter-dashboard-banner"
				data-testid="starter-dashboard-banner"
				role="alert"
				dismissable={data.banner.dismissable}
				primaryAction={castToPageMessageAction(data.banner.primaryAction)}
				secondaryAction={castToPageMessageAction(data.banner.secondaryAction)}
				severity={data.banner.severity}
				message={data.banner.message}
				onClose={actions.onDismiss}
				sx={{ position: 'sticky', top: 0, zIndex: 1 }}
			/>
		</div>
	);
};
